import DashboardBerthingManagement from './dashboard-berthing-management.container'

export default DashboardBerthingManagement